import { TypeToIconInfoMap } from 'components/ModelTypeIcon/constants';

export const EntityCardModelTypeIcon = ({ modelTypeId, size }: { modelTypeId: string; size: number | string }): JSX.Element => {
  const { shadow, IconElement } = TypeToIconInfoMap[modelTypeId] || TypeToIconInfoMap.default;
  return <IconElement color="white" bgColor={shadow} size={size} />;
};
